import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface EmailAttachment {
  id: string;
  email_message_id: string;
  filename: string;
  content_type: string;
  attachment_id: string;
  size_bytes: number;
  created_at: string;
}

export function useAttachments(emailId: string | undefined) {
  return useQuery({
    queryKey: ['email-attachments', emailId],
    queryFn: async () => {
      if (!emailId) return [];

      const { data, error } = await supabase
        .from('email_attachments')
        .select('*')
        .eq('email_message_id', emailId)
        .order('filename');

      if (error) throw error;
      return data as EmailAttachment[];
    },
    enabled: !!emailId,
  });
}
